import React, { useEffect } from "react";
import styles from "../ArticleComponents/Common.module.css";
import ArticleCoverAndHeader from "../ArticleComponents/ArticleCoverAndHeader";
import styles1 from "./DonatePlasma.module.css";
import Row from "../ArticleComponents/Row";
function DonatePlasma() {
  const row1 = {
    listItem: [
      "Donated plasma is frozen within 24 hours of being donated to preserve its valuable clotting factors. Red Cross donations are often used directly for hospital patient transfusions, rather than pharmaceutical uses. ",
      "The donated Plasma from the donors is recovered back in 48hours of donation.",
    ],
  };

  const row2 = {
    heading: "Who cannot donate plasma?:",

    listItem: [
      "Pregnant women ",
      "Patients with high BP or diabetes or thyroid ",
      "Individuals who weigh less than 50 kg ",
      "Individuals who have taken plasma themselves",
      "Cancer survivors",
      "Individuals who have chronic kidney / heart / lung or liver disease",
      "Persons with comorbidities ",
      "Individuals who have taken any COVID-19 vaccine will not be able to donate for 15 days from the date of the second dose.",
    ],
  };
  const row3 = {
    heading: "Eligibility criteria for plasma donors:",
   
    listItem: [
      "Tested COVID +ve in last 120 days ",
      "Recovered from covid and various symptoms",
      "Should not have symptoms for last 14 days ",
      "Weight at least 50kg ",
      "Should be between 18-65 yrs. of age",
    ],
  };

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });

  const refList = {
    heading: "Plasma Donation Links",
    linkList: [{linkTitle:"dhoondh.com",link:"https://dhoondh.com/"},
    {linkTitle:"plasmadonor.in",link:"https://plasmadonor.in/"},
    {linkTitle:"needplasma.in",link:"https://needplasma.in/"},
    {linkTitle:"plasmaline.in",link:"https://plasmaline.in/"},
    {linkTitle:"friends2support.org",link:"http://friends2support.org/"},
    {linkTitle:"covidplasma.online",link:"https://covidplasma.online/"},]
  }
  

  return (
    <ArticleCoverAndHeader
      readTime={4}
      title="Why and How to Donate Plasma?"
      author="Prataksha Gupta"
      authorLink="https://www.instagram.com/pratyaksha.gupta/"
      author2="Rajat Prasad"
      authorLink2="https://www.instagram.com/rajat__prasad/"
      previousGuide="/homeRemedies"
      nextGuide="/getVaccinated"
    >
      <div className={styles.introPara}>
        <p>
          Simply, Plasma donors are needed because lives depend on plasma
          protein therapies. Donating plasma is often called,<span className={styles.highlight}>
          "the gift of life."</span> plasma
          donation and blood donation are critically important activities that
          contribute to saving lives. For many with rare diseases, these are the
          only therapies available to treat these chronic conditions.When you
          get infected, the body makes antibodies to fight the virus.These
          <span className={styles.highlight}> antibodies now reside in your plasma</span>,and can help you save others when
          you donate plasma.
        </p>
      </div>

      <div className={styles1.imgSection}>
        <img
          src="https://drive.google.com/thumbnail?id=15DyShgpI2cAjWDuryNXMMqJMhhN-AlNO"
          alt="associated-image"
        />
      </div>

      <h2 className={styles.sliderHeader}>WHAT IS PLASMA DONATION?</h2>
      <div className={styles.introPara}>
        <p>
          In a plasma donation, the <span className={styles.highlight}>liquid portion of the donor’s blood is
          separated from the cells</span>. Blood is drawn from one arm and sent through
          a high-tech machine that collects the plasma. The donor’s red blood
          cells and platelets are then returned to the donor along with some
          saline.{" "}
          <span className={styles.highlight}>
            The process is safe and only takes a few minutes longer than
            donating whole blood
          </span>
        </p>
      </div>
     
      <Row row={row2} />
      <img src="https://tbsnews.net/sites/default/files/styles/very_big_3/public/images/2020/05/28/plasma_collection_still_behind_demand_final.jpg?itok=OIXMkkMw" alt=""/>
      <Row row={row3}/>
      <div className={styles.rowCover}>
        <h3>Procedure for donating plasma:</h3>
        <div className={styles.row}>
          <div className={styles.column}>
            <ul className={styles.list}>
              <li>Ensure you meet the given criteria</li>
              <li>Visit your nearest hospital / plasma bank center</li>
              <li>
                Undergo various tests to map the status of the serum protein,
                CBC (Complete Blood Count) and ABO RhD blood group.
              </li>
              <li>
                Other tests include checked for hepatitis B, hepatitis C, HIV,
                malaria and syphilis.
              </li>
              <li>
                Depending on how many days have passed since the recovery, the
                donor will also have to take an antibody screening test
              </li>
              <li>
                If you are eligible (pass all tests) you will be allowed to
                donate plasma.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <h2 className={styles.sliderHeader}>
        How many times can a person donate and how much?
      </h2>

      

      <div className={styles.introPara}>
        <p>
          As per ICMR guidelines, a donor can donate up to <span className={styles.highlight}>500 ml of plasma
          (according to weight) more than once, with a gap of 15 days</span>. 400 ml of
          blood can save two lives. The process can last up to four hours (from
          tests to transfusion), and if the patient experiences discomfort, the
          machine can be detached immediately.
        </p>
      </div>

      <Row row={refList} links/>
    </ArticleCoverAndHeader>
  );
}

export default DonatePlasma;
